<template>
  <v-container fluid grid-list-xs fill-height>
    <v-layout row wrap>
        <v-flex sm3 md3>
          <sidebar/>
        </v-flex>
        <v-flex sm9 md9>
          <router-view :bankByBrand="bankByBrand"/>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import Sidebar from './Sidebar'
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  components: {
    Sidebar
  },
  created() {
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    bankByBrand() {
      return this.accounts.filter(item => item["brand"] === this.selectedBrand);
    },
  },
}

</script>


// WEBPACK FOOTER //
// src/components/Informations/index.vue